import React from 'react';

import {Text} from '@optimaxdev/design-system';

/**
 * Gets the content for visibly error page
 */
export const getVisiblyErrorContent = (
    stateName: string,
): {
    [key: string]: {
        text: React.ReactNode;
        title: string;
    }[];
} => ({
    age: [
        {
            text: 'The Visibly vision test is not available for patients under 18 or over 55.',
            title: "Sorry, you're outside the age range.",
        },
        {
            text: 'If you are actually between 18-55, enter your details again.',
            title: 'Entered the wrong age?',
        },
    ],
    region: [
        {
            text: (
                <>
                    Due to regulations,{' '}
                    <Text color="inherit" bold>
                        {stateName}
                    </Text>{' '}
                    is excluded from the Visibly vision test.
                </>
            ),
            title: 'Sorry, your state is not eligible.',
        },
        {
            text: 'Update your details and try again.',
            title: 'Entered the wrong state?',
        },
    ],
});
